import React from 'react';
import { CondensedMedium, Flashy, Icon, Layout } from '@axiom/ui';

import type { MatchChecklistItem } from './OpportunityTalentMatchSummaryChecklistUtil';

export const OpportunityTalentMatchSummaryChecklistItem = ({
  id,
  isMatched,
  children,
}: MatchChecklistItem) => {
  return (
    <Layout horizontalGutter="8px" position="left middle" name={id}>
      <CondensedMedium name="checklist-item">
        <Flashy
          color={isMatched ? 'dataVizGreen' : 'dataVizYellow'}
          name={`checklist-item-${isMatched ? 'matched' : 'unmatched'}`}
        >
          <Layout position="middle">
            <Icon name={isMatched ? 'circle-check-filled' : 'alert-filled'} />
          </Layout>
        </Flashy>
      </CondensedMedium>
      <CondensedMedium>{children}</CondensedMedium>
    </Layout>
  );
};
